import React from 'react'
import * as common from '../component/common'
import { useMediaQuery } from 'react-responsive';

const Home = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <>
    {/* <common.floatingComponent/> */}
    { isMobile ? 
      <common.MobileBanner />
      :<common.Banner/>
    }
    <common.ModernSection />
    <common.Amenities />
    {
      isMobile ?
      <common.MobileGallery />
      :<common.Gallery />
    }
    
    <common.Facing />
    <common.Location />
    <common.Living />
    <common.Pricing />
    <common.VoiceUnlocked/>
    {/* <common.Plan /> */}
    <common.Offer />
    <common.Visit />
    <common.Contact />
    <common.Footer />
    </>
  )
}

export default Home
